import styled from "styled-components";
import { devices } from "../../utilities/responsive";

export const Header = styled.header`
  z-index: 9999;
  width: 100%;
  position: absolute;
`;

export const Navigation = styled.nav<{ sticky: boolean; isVisible: boolean }>`
  z-index: 9999;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  padding: ${({ sticky }) => (sticky ? ".5rem 5vw" : "1.5rem 5vw")};
  box-shadow: ${({ sticky }) =>
    sticky ? "0 0.3rem 1rem rgba(0, 0, 0, 0.03)" : "none"};
  display: flex;
  align-items: center;
  transition: all 0.3s ease;

  .nav__brand {
    height: 9rem;
    transition: all 0.3s ease;
    padding-bottom: ${({ sticky }) => (sticky ? "10px" : "0")};

    @media ${devices.phone} {
      height: 7.5rem;
    }

    a {
      margin: 0 auto;

      &::after {
        content: none;
      }

      .unitiva-logo {
        @media screen and (min-width: 850px) and (max-width: 900px) {
          width: ${({ sticky }) => (sticky ? "80px" : "87px")};
        }
        @media screen and (min-width: 901px) and (max-width: 980px) {
          width: ${({ sticky }) => (sticky ? "110px" : "120px")};
        }
        width: ${({ sticky }) => (sticky ? "150px" : "170px")};
        height: 8rem;
        transition: all 0.3s ease;

        #logo-wordmark {
          transition: all 0.3s ease;
          opacity: ${({ sticky }) => (sticky ? "0" : "1")};
        }
      }
    }
  }

  .nav__links {
    margin-left: auto;

    @media ${devices.tabletPortrait} {
      display: none;
    }

    ul {
      display: flex;
      align-items: center;
      list-style: none;

      li {
        overflow: hidden;
        margin-bottom: 0;
        padding-bottom: 10px;

        &:not(:last-child) {
          margin-right: 4rem;
          @media ${devices.desktop} {
            margin-right: 2rem;
          }
        }

        &:last-child {
          margin-left: 6rem;
          @media ${devices.desktop} {
            margin-left: 1rem;
          }
        }

        a {
          position: relative;
          text-decoration: none;
          color: var(--white);
          font-size: 1.55rem;
          font-weight: 800 !important;
          height: 100%;
          letter-spacing: 0.8px;
          padding-bottom: 0.2rem;
          transition: 0.3s color ease;

          @media ${devices.desktopLg} {
            font-size: 2rem;
          }

          &:after {
            content: "";
            position: absolute;
            width: 100%;
            height: 5px;
            border-radius: 1rem;
            bottom: -3px;
            left: 0;
            transform: translateX(-105%);
            background: linear-gradient(to left, #654ad2, #36b1bd);
            transition: transform 0.3s ease;
          }

          &:hover {
            color: var(--primary-on-hover);

            &:after {
              transform: translateX(0);
            }
          }
        }

        button {
          position: relative;
          text-decoration: none;
          color: var(--white);
          font-size: 1.55rem;
          font-weight: 800 !important;
          height: 100%;
          letter-spacing: 0.8px;
          transition: 0.3s color ease;
          background-color: transparent;
          border: none;
          font-family: "Nunito Sans", sans-serif;

          @media ${devices.desktopLg} {
            font-size: 2rem;
          }

          &:after {
            content: "";
            position: absolute;
            width: 100%;
            height: 5px;
            border-radius: 1rem;
            bottom: -3px;
            left: 0;
            transform: translateX(-105%);
            background: linear-gradient(to left, #654ad2, #36b1bd);
            transition: transform 0.3s ease;
          }

          &:hover {
            cursor: pointer;

            &:after {
              transform: translateX(0);
            }
          }
        }

        .career {
          @media screen and (min-width: 850px) and (max-width: 950px) {
            padding: 4px 8px;
          }
          padding: 4px 24px;
          font-weight: 800 !important;
          color: var(--white) !important;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          border-radius: 4px;
          background: linear-gradient(
            to right,
            #654ad2 0%,
            #2173cf 40%,
            #247ccc 49%,
            #36b1bd 100%
          );
          background-size: 120%;
          transition: all 0.3s ease;

          &.active {
            background: var(--primary);
          }

          &:after {
            content: none;
          }

          &:hover {
            background-position: 100% 0;
          }

          span {
            display: block;
            margin-top: -4px;
            font-size: 12px;
            font-weight: 300;
            color: var(--white) !important;
            text-align: center;
          }
        }

        .active {
          color: var(--eyebrow-color);

          &:after {
            transform: translateX(0);
          }
        }
      }
    }
  }

  .nav__menu {
    position: relative;
    margin-left: auto;
    width: 4rem;
    height: 4rem;
    padding: 1rem;
    cursor: pointer;
    display: none;
    box-sizing: content-box;

    @media ${devices.tabletPortrait} {
      display: block;
    }

    & > * {
      pointer-events: none;
    }

    &:hover {
      circle {
        stroke-dasharray: 380;
      }
    }

    svg {
      fill: transparent;
      position: absolute;
      left: 0;
      top: 0;
      stroke-width: 2;
      width: auto;
      height: auto;

      circle {
        stroke: var(--primary);
        stroke-dasharray: 190;
        stroke-dashoffset: 190;
        transition: all 0.3s ease;
      }
    }

    &__icon {
      width: 2.5rem;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);

      span {
        display: block;
        background-color: var(--primary);
        width: 100%;
        height: 0.2rem;
        transition: transform 0.3s ease;

        &:nth-child(2) {
          width: 70%;
        }

        &:nth-child(3) {
          width: 40%;
        }

        &:not(:last-child) {
          margin-bottom: 0.5rem;
        }
      }
    }
  }

  .is__open {
    circle {
      stroke-dasharray: 380;
    }

    .nav__menu__icon {
      span {
        transform: rotate(45deg);

        &:nth-child(2) {
          opacity: 0;
        }

        &:nth-child(3) {
          transform: rotate(-45deg);
          margin-top: -1.4rem;
          width: 100%;
        }
      }
    }
  }

  .nav__links ul {
    margin-left: 1em;
  }

  &.sticky__dark__nav {
    background-color: var(--dark);

    .nav__links ul li a {
      color: var(--white);
    }

    .nav__links ul li button {
      color: var(--white);
    }
  }

  &.sticky__white__nav {
    background-color: ${({ sticky }) =>
      sticky ? "var(--white)" : "transparent"};

    .nav__links ul li a {
      color: var(--primary);
    }

    .nav__links ul li button {
      color: var(--primary);
    }
    &.menu__open {
      background-color: #fdfdfd;
    }
  }

  .arrow {
    height: 100%;
    padding-bottom: 2px;
  }

  .arrow-container {
    rotate: ${({ isVisible }) => (isVisible ? "180deg" : "0deg")};
    transition: all 0.3s ease;
    transform-origin: 50% 50%;
  }

  .solution-button {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 5px;
    flex-wrap: wrap;
    align-content: center;
  }
`;

export const Overlay = styled.div`
  will-change: transform;
  padding: 0 5vw;
  z-index: 9998;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  background-color: var(--white);
  transform: translateY(-150vh);
  transition: transform 0.5s ease;

  &.menu__dark {
    background-color: var(--dark);
    .nav__overlay__links {
      > ul li {
        a {
          color: var(--lighter-gray);
        }
        &.active a,
        &:focus a,
        &:hover a {
          color: var(--white) !important;
        }
      }
      ul {
        div {
          border-top: 1px solid #d6d2d2;
          border-bottom: 1px solid #d6d2d2;
          h3,
          button {
            color: #d6d2d2;
          }
        }
      }
    }
  }

  .container {
    position: absolute;
    width: initial;
  }

  .nav__overlay__links {
    margin-top: -100vh;

    @media ${devices.tabletPortrait} {
      margin-top: 12rem;
    }

    ul {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      margin-left: 0;
      padding: 0 !important;

      @media ${devices.tabletPortrait} {
        flex-direction: column;
        align-items: flex-start;
      }

      li {
        overflow: hidden;
        opacity: 1;
        margin-bottom: 1rem;

        &.active a {
          color: var(--primary-on-hover) !important;
        }

        &:not(:last-child) {
          margin-right: 3.5rem;
        }

        a {
          text-transform: uppercase;
          font-weight: 800;
          letter-spacing: 2px;
          margin-bottom: 1rem;
          padding-bottom: 1rem;
          border-bottom: 7px solid #fff;
          transition: all 0.3s ease;

          &:hover {
            color: var(--primary-on-hover) !important;
          }

          @media ${devices.tabletPortrait} {
            font-size: 4vh;
          }
        }
      }
    }
  }
`;

export const HoverMenu = styled.div<{ isVisible: boolean }>`
  display: flex;
  background-color: #fdfdfd;
  width: 100%;
  min-height: 470px;
  height: auto;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.1);
  z-index: 9998;
  position: fixed;
  top: ${({ isVisible }) => (isVisible ? "100px" : "-1000px")};
  flex-direction: row;
  flex-wrap: nowrap;
  color: var(--primary);
  justify-content: space-around;
  padding: 32px;
  transition: top 0.5s ease-in-out;

  &.menu__dark {
    background-color: var(--dark);

    div ul li a {
      color: var(--white);
      transition: color 0.3s ease;
    }

    div ul li a:hover {
      color: #36b0bd;
    }

    .header {
      color: var(--white);
    }

    .column__divider {
      border-left: #fff 1px solid;
    }
  }
  @media (max-width: 850px) {
    display: none;
  }
`;

export const HoverMenuColumn = styled.div`
  padding: 1rem;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  @media ${devices.desktopLg} {
    padding: 0.8rem;
  }

  ul {
    padding-left: 0;
    list-style-type: none;
    margin-left: 0;
  }

  ul li {
    padding: 10px;

    h3 {
      margin: 0;
      letter-spacing: 0;
      margin-bottom: 1rem;
    }
  }

  ul li a {
    font-weight: 500 !important;
    font-size: 1.55rem;
    transition: color 0.3s ease;

    @media ${devices.desktopLg} {
      font-size: 2rem;
    }
  }

  ul li a:hover {
    color: #36b0bd !important;
  }

  .header a,
  .header {
    font-weight: 800 !important;
    font-size: 1.55rem;
    text-transform: none;
    @media ${devices.desktopLg} {
      font-size: 2rem;
    }
  }

  &.column__divider {
    border-left: #4260d1 1px solid;
  }
`;
export const MobileMegaMenu = styled.div`
  @media (min-width: 851px) {
    display: none;
  }
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  margin-bottom: 1rem;
  border-top: #4260d1 1px solid;
  border-bottom: #4260d1 1px solid;
  padding: 0.8rem;
  h3 {
    color: var(--primary);
    text-transform: uppercase;
    font-weight: 700;
    padding-top: 0.8rem;
    margin: 0;

    @media ${devices.tabletPortrait} {
      font-size: 4vh;
    }
  }

  button {
    display: flex;
    flex-direction: row;
    text-decoration: none;
    color: var(--primary);
    font-size: 2.5vh;
    font-weight: 800 !important;
    background-color: transparent;
    border: none;
    font-family: "Nunito Sans", sans-serif;
    padding: 1rem;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    flex-wrap: wrap;
    cursor: pointer;
    span {
      display: flex;
      align-items: center;
    }
    &:hover {
      color: var(--primary-on-hover);
    }
  }
`;
export const MobileMegaMenuOverlay = styled.div`
  @media (min-width: 851px) {
    display: none;
  }
  will-change: transform;
  padding: 0 5vw;
  z-index: 9999;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  background-color: var(--white);
  transform: translateX(-1000vh);
  transition: transform 0.4s ease-in-out;

  &.menu__dark {
    background-color: var(--dark);
    .container {
      button {
        span:last-child {
          color: var(--white);
          text-decoration-color: var(--white);
        }
      }
      ul li {
        h3 a,
        a {
          color: var(--lighter-gray) !important;
        }
      }
    }
  }

  &:not(.menu__dark) .container button span:last-child {
    color: var(--primary) !important;
  }

  .container {
    display: flex;
    flex-direction: column;
    position: relative;
    width: initial;
    top: 20vh;

    span {
      text-decoration: underline;
      text-decoration-color: var(--primary);
      color: var(--primary);
      text-underline-offset: 2px;
    }
  }

  button {
    display: flex;
    flex-direction: row;
    text-decoration: none;
    color: var(--primary);
    font-size: 2.5vh;
    font-weight: 500 !important;
    background-color: transparent;
    border: none;
    font-family: "Nunito Sans", sans-serif;
    padding: 1rem;
    justify-content: start;
    align-items: center;
    width: 100%;
    flex-wrap: wrap;
    border-bottom: #4260d1 1px solid;
    cursor: pointer;
    span {
      display: flex;
      align-items: center;
      padding-right: 1rem;
    }
    img {
      rotate: 180deg;
    }
  }

  ul {
    margin-left: 0;
    list-style-type: none;

    h3 {
      margin: 0;
      text-transform: none;
      letter-spacing: 0;

      a {
        position: relative;
        color: var(--primary);
        font-size: 2.8vh;
        font-weight: 800;
        padding-block: 1rem;
        margin: 0.5rem 0;
      }
    }

    a {
      color: var(--primary) !important;
      font-size: 2.5vh;
      /* font-weight: 500!important; */
      padding: 1rem 0;
      text-decoration: none;
      display: inline-block;

      &:hover {
        color: var(--primary-on-hover);
      }
    }
  }
`;
